import { authAdminThunk } from "redux/actions/authActions";
import { useAppDispatch } from "redux/store";
import BaseToastContainer from "containers/baseToastContainer/baseToastContainer";
import { ErrorBoundary } from "containers/errorBoundary/errorBoundary";
import MainLayout from "containers/layout/mainLayout";
import MainLoader from "containers/mainLoader/mainLoader";
import BaseModalContainer from "containers/modalContainers/baseModalContainer";
import "hammerjs";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { removeUserLocalStorageData } from "utils/storageActions";
import "react-toastify/dist/ReactToastify.css";
import { useBroadcastChannel } from "utils/customHooks";

const App = () => {
    const [isReady, setIsReady] = useState(false);
    const [searchParams] = useSearchParams();
    const dispatch = useAppDispatch();
    const impersonateLoginRequestToken = searchParams.get("token");

    // See if user can reconnect (from local storage token).
    useEffect(() => {
        // if its a impersonate login request, remove user data from local storage.
        if (impersonateLoginRequestToken) {
            removeUserLocalStorageData();
            useBroadcastChannel("authentication", "logout");
            setIsReady(true);
        } else {
            dispatch(authAdminThunk()).then(() => {
                setIsReady(true);
            });
        }
    }, []);

    return (
        <div className="app">
            <ErrorBoundary>
                <MainLoader />
                {isReady && (
                    <>
                        <BaseModalContainer />
                        <BaseToastContainer />
                        <MainLayout />
                    </>
                )}
            </ErrorBoundary>
        </div>
    );
};

export default App;
